import { API_URL } from 'constants/application';
import { authorizedGET, authorizedPOST } from 'helpers/requester_next';

const url = `${API_URL}/tag`;

export const getTags = () => authorizedGET(`${url}`);
export const addTag = (body) => authorizedPOST(`${url}`, body);